const rawSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0z" fill="currentColor" /></svg>`;
import { createSvgIcon } from "@/application/utils/createSvgIcon";

export default createSvgIcon(rawSvg);
